<div class="current-workflow">
  <mat-accordion multi="true">
    <p class="timestamp-text paragraph-medium-regular">
      Last generated:
      <span>
        {{ timestamp ? timestamp.toLocaleDateString() + ', ' + timestamp.toLocaleTimeString() : '-' }}
      </span>
    </p>
    <app-add-reference-card *ngIf="!isLoadingData && !timestamp && !isLoading"
      [desc]="isGenerateWorkflowError ? 'Error generating a workflow.' : 'Click validate to generate the workflow for this document'"></app-add-reference-card>
    <app-add-reference-card
      *ngIf="!isLoadingData && !isLoading && timestamp && dataSource.rfs.length===0 && dataSource.budget.length===0 && dataSource.woc.length===0 && dataSource.quotation.length==0 && dataSource.vendor.length===0 &&
            dataSource.sow.length===0 && dataSource.CEAssignment.length===0 &&  dataSource.tenderDocument.length ===0 && dataSource.tenderDocumentApproval.length===0"
      desc="There is no workflow generated for this document"></app-add-reference-card>
    <!-- <div *ngIf="isLoadingData">
      <mat-spinner class="mydocs-spinner" ></mat-spinner>
      <div class="mydocs-spinner-text paragraph-medium-regular"><p>Retrieving data...</p></div>
    </div> -->
    <app-loader [isLoading]="isLoading || isLoadingData"></app-loader>
    <mat-expansion-panel hideToggle="true" #panel *ngIf="dataSource.rfs.length > 0 && !isLoadingData && !isLoading" [expanded]="true">  
      <mat-expansion-panel-header>
        <mat-panel-title class="title">
          <mat-icon class="expansion-arrow">{{
            panel.expanded ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          <div>Request for sourcing</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <app-workflow-table [dataSource]="dataSource.rfs" [displayedColumns]="displayedColumns">
        </app-workflow-table>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle="true" #panel *ngIf="dataSource.budget.length > 0" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">
          <mat-icon class="expansion-arrow">{{
            panel.expanded ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          <div>Approval of Requirement</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div *ngFor="let budgetGroup of dataSource.budget" class="budget-group">
        <div class="table-title paragraph-medium-regular">
          <span class="budget-type">{{ budgetGroup.type }}: </span>{{ budgetGroup.group }}
        </div>
        <table mat-table [dataSource]="budgetGroup.recordList" class="mat-elevation-z1">
          <ng-container matColumnDef="personel">
            <th mat-header-cell *matHeaderCellDef>Personnel</th>
            <td mat-cell *matCellDef="let element">
              <ng-template [ngIf]="element.IsCovering">
                {{ element.CoveringName }}
                <app-covering-officer-chip [originalPersonnelName]="element.PersonnelName"></app-covering-officer-chip>
              </ng-template>
              <ng-template [ngIf]="!element.IsCovering">{{ element.PersonnelName}}</ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="appointment">
            <th mat-header-cell *matHeaderCellDef>Appointment</th>
            <td mat-cell *matCellDef="let element">
              {{ element.Appointment }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">{{ element.Action }}</td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let element">
              {{ element.Date ?? '' | date : "dd/MM/yy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="comment">
            <th mat-header-cell *matHeaderCellDef>Comments</th>
            <td mat-cell *matCellDef="let element">
              {{ element.Comment ?? "-" }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle="true" #panel *ngIf="dataSource.woc.length > 0" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">
          <mat-icon class="expansion-arrow">{{
            panel.expanded ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          <div>{{ ( purchaseTypeId == 5 && EstimatedItemAmount > 200000 ) ? 'Waiver of competition/Dispensation of tendering process' : 'Waiver of competition' }}</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <app-workflow-table [dataSource]="dataSource.woc" [displayedColumns]="displayedColumns">
        </app-workflow-table>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle="true" #panel *ngIf="dataSource.quotation.length > 0" [expanded]="true">  
      <mat-expansion-panel-header>
        <mat-panel-title class="title">
          <mat-icon class="expansion-arrow">{{
            panel.expanded ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          <div>Quotation upload</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <app-workflow-table [dataSource]="dataSource.quotation" [displayedColumns]="displayedColumns">
        </app-workflow-table>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle="true" #panel *ngIf="dataSource.vendor.length > 0" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">
          <mat-icon class="expansion-arrow">{{
            panel.expanded ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          <div>Vendor document approval</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <app-workflow-table [dataSource]="dataSource.vendor" [displayedColumns]="displayedColumns">
        </app-workflow-table>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle="true" #panel *ngIf="dataSource.sow.length > 0" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">
          <mat-icon class="expansion-arrow">{{
            panel.expanded ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          <div>Scope of work</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <app-workflow-table [dataSource]="dataSource.sow" [displayedColumns]="displayedColumns">
        </app-workflow-table>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle="true" #panel *ngIf="dataSource.CEAssignment.length > 0" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">
          <mat-icon class="expansion-arrow">{{
            panel.expanded ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          <div>Contracting executive assignment</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <app-workflow-table [dataSource]="dataSource.CEAssignment" [displayedColumns]="displayedColumns">
        </app-workflow-table>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle="true" #panel *ngIf="dataSource.tenderDocument.length > 0" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">
          <mat-icon class="expansion-arrow">{{
            panel.expanded ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          <div>Tender document preparation</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <app-workflow-table [dataSource]="dataSource.tenderDocument" [displayedColumns]="displayedColumns">
        </app-workflow-table>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle="true" #panel *ngIf="dataSource.tenderDocumentApproval.length > 0" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">
          <mat-icon class="expansion-arrow">{{
            panel.expanded ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          <div>{{ purchaseTypeId == 5 ? 'Contract preparation' : 'Tender document approval' }}</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <app-workflow-table [dataSource]="dataSource.tenderDocumentApproval" [displayedColumns]="displayedColumns">
        </app-workflow-table>
      </div>
    </mat-expansion-panel>

  </mat-accordion>


</div>
